import { createRouter, createWebHistory } from "vue-router";
import Sign from "../views/pages/sign/index.vue";

// My pages
import Home from "../views/pages/home/index.vue";
import PersonalInfo from "../views/pages/PersonalInfo.vue";
import Security from "../views/pages/Security.vue";
import User from "../views/pages/user/index.vue";
import Cpd from "../views/pages/cpd/index.vue";
import Team from "../views/pages/team/index.vue";
import Docs from "../views/pages/docs/index.vue";
import DocsEmbed from "../views/pages/docs/embed/index.vue";
import DocsRef from "../views/pages/docs/ref/index.vue";

// Layouts
import LayoutHeadMenu from '../views/layouts/head-menu.vue';
import LayoutEmpty from '../views/layouts/empty.vue';

// Middleware
import profile from "../middleware/profile";
import logged from "../middleware/logged";
import redirectIfLogged from "../middleware/redirectIfLogged";

export default ({app}) => {
  const routes = [
    // My pages
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        layout: LayoutHeadMenu,
        middleware: [profile, logged]
      }
    },

    {
      path: "/docs",
      name: "docs",
      component: Docs,
      meta: {
        layout: LayoutHeadMenu,
        middleware: [profile, logged]
      }
    },

    {
      path: "/docs/embed",
      name: "docs-embed",
      component: DocsEmbed,
      meta: {
        layout: LayoutHeadMenu,
        middleware: [profile, logged]
      }
    },

    {
      path: "/docs/ref",
      name: "docs-ref",
      component: DocsRef,
      meta: {
        layout: LayoutHeadMenu,
        middleware: [profile, logged]
      }
    },

    {
      path: "/users",
      name: "users",
      component: User,
      meta: {
        layout: LayoutHeadMenu,
        middleware: [profile, logged]
      }
    },

    {
      path: "/teams",
      name: "teams",
      component: Team,
      meta: {
        layout: LayoutHeadMenu,
        middleware: [profile, logged]
      }
    },

    {
      path: "/cpds",
      name: "cpds",
      component: Cpd,
      meta: {
        layout: LayoutHeadMenu,
        middleware: [profile, logged]
      }
    },

    {
      path: "/personal-info",
      name: "personal-info",
      component: PersonalInfo,
      meta: {
        layout: LayoutHeadMenu,
        middleware: [profile, logged]
      }
    },

    {
      path: "/security",
      name: "security",
      component: Security,
      meta: {
        layout: LayoutHeadMenu,
        middleware: [profile, logged]
      }
    },

    {
      path: "/signin",
      name: "Signin",
      component: Sign,
      meta: {
        layout: LayoutEmpty,
        middleware: [profile, redirectIfLogged]
      }
    },
  ];

  const router = createRouter({
    mode: 'history',
    history: createWebHistory(process.env.BASE_URL),
    routes,
    linkActiveClass: "active",
  });

  router.beforeEach((to, from, next) => {
    /** Navigate to next if middleware is not applied */
    if (!to.meta.middleware) {
      return next();
    }

    const context = {
      to,
      from,
      router,
      app
      //   store  | You can also pass store as an argument
    };
    let index = -1;

    const __next = function (path = undefined) {
      index++;

      if (path || !to.meta.middleware[index]) {
        return next(path);
      }

      return to.meta.middleware[index]({ ...context, next: __next });
    };

    return __next();
  });

  return router;
};

